import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './pages/Home';
import Detail from './pages/Vaishno-devi';
import VishwanathTemple from './pages/Kashi-vishwanath'; 
import KedarnathTemple from './pages/Kedarnath-temple';  
import AmarnathTemple from './pages/Amarnath-temple';
import DwarkadhishTemple from './pages/Dwarkadhish-temple';
import RamanathaswamyTemple from './pages/Ramanathaswamy-temple';
import About from './pages/About';
import Header from './layout/header/Header';
import Footer from './layout/footer/Footer';
import Contact from './pages/Contact';
import RefundPolicy from './pages/Refund-policy';
import Privacy from './pages/Privacy';
import TermsCondition from './pages/terms';
import reportWebVitals from './reportWebVitals';
import Locker from './pages/Locker';
import DetailListing from './pages/Listing';
import { Provider } from 'react-redux';
import store from './store/store';
import AyodhyaTemple from './pages/Ayodhya-temple';
import Career from './pages/Career';
import Thanks from './pages/Thanks'; 
import Hotel from './pages/hotel-page/hotel';
import HotelList from './pages/hotel-page/hotel-list';
import Vrdarshan from './pages/Vr-darshan';
import VrDarshanNew from './pages/vr-darshan/darshan-list';
import TrendingPage from './pages/trending/trending';
import FormUpload from './pages/forms/Upload-form';
import TrendingDetail from './pages/trending/trending-detail';
import ContestPage from './pages/contest/contest';
import Comingsoon from './pages/Coming-soon';
import NotFoundFun from './pages/404';
import HotelDetail from './pages/hotel-page/hotel-detail';
import HotelPayment from './pages/hotel-page/hotel-payment';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="/vaishno-devi" element={<Detail />} />
          <Route path="/kashi-vishwanath" element={<VishwanathTemple />} /> 
          <Route path="/kedarnath" element={<KedarnathTemple />} /> 
          <Route path="/amarnath" element={<AmarnathTemple />} />
          <Route path="/dwarkadhish-temple" element={<DwarkadhishTemple />} />
          <Route path="/ramanathaswamy-temple" element={<RamanathaswamyTemple />} />
          <Route path="/ayodhya" element={<AyodhyaTemple />} /> 
          <Route path="/about-us" element={<About />} />
          <Route path="/contact-us" element={<Contact />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/terms-condition" element={<TermsCondition />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/locker" element={<Locker />} />
          <Route path="/listing" element={<DetailListing />} />
          <Route path="/career" element={<Career />} />
          <Route path="/thanks" element={<Thanks />} />
          <Route path="/hotel" element={<Hotel />} />
          <Route path="/hotel-list" element={<HotelList />} />
          <Route path="/hotel-detail" element={<HotelDetail />} />
          <Route path="/payment" element={<HotelPayment />} />
          <Route path="/vr-darshan-old" element={<Vrdarshan />} />
           <Route path="/vr-darshan" element={<VrDarshanNew />} />
          <Route path="/trending" element={<TrendingPage />} />
          <Route path="/trending-detail" element={<TrendingDetail />} />
<Route path="/upload-form" element={<FormUpload />} />
          <Route path="/contest" element={<ContestPage />} />

          <Route path="/coming-soon" element={<Comingsoon />} />
          <Route path="/landingpage/app" element={<Comingsoon />} />
          <Route path="*" element={<NotFoundFun />} />

        </Routes>
        <Footer />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
